import ApiClient from '../shared/ApiCliente';

export type AnaliseImpacto = 'POSITIVO' | 'NEGATIVO' | 'NEUTRO';

export type AnaliseNoticiaDto = {
  url: string;
  titulo: string;
  data: string | null;
};

export type AnaliseEmpresaDto = {
  id: string;
  nome: string;
  tickerPrincipal?: string | null;
};

export type AnaliseDetalheDto = {
  analise: string;
  fato: string;
  impacto: string;
  dataProcessamento: string;
  empresa: AnaliseEmpresaDto | null;
  noticias: AnaliseNoticiaDto[];
};

export const analiseService = {
  getByTexto: async (texto: string): Promise<AnaliseDetalheDto | null> => {
    try {
      const response = await ApiClient.get<AnaliseDetalheDto>('/analises', {
        params: { texto },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar análise:', error);
      return null;
    }
  },

  updateImpacto: async (
    texto: string,
    impacto: AnaliseImpacto
  ): Promise<AnaliseDetalheDto | null> => {
    try {
      const response = await ApiClient.patch<AnaliseDetalheDto>(
        '/analises',
        { impacto },
        { params: { texto } }
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar impacto da análise:', error);
      throw error;
    }
  },
};
